export default {"src":"/_next/static/media/member-taking-urine-test.mono.0e7240a8.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};